var map = {
	"./1.png": 2321,
	"./POIgeneric.jpg": 2322,
	"./cmentarz.jpg": 2323,
	"./hotel.jpg": 2324,
	"./kosciol.jpg": 2325,
	"./kultura.jpg": 2326,
	"./map-icon.png": 2327,
	"./przyroda.jpg": 2328,
	"./rekreacja.jpg": 2329,
	"./schronisko.jpg": 2330,
	"./swieczki.jpg": 2316,
	"./szkola.jpg": 2331,
	"./transport.jpg": 2332,
	"./x.png": 2314,
	"./zabytek.jpg": 2333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;



//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img ^\.\/.*$
// module id = 2320
// module chunks = 0